import SortingDesktop from './sorting-desktop';

export default SortingDesktop;